module.exports = __webpack_public_path__ + "6c3152f14a8884e14964ab60d619ff92.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/intro-bg.png
// module id = 886
// module chunks = 3